/* Shared by Paper and Card. Mantine's own scheme rule sets the border
   colour (gray-3 / dark-4) at a higher specificity, so it is left alone. */
.root {
    background-color: var(--mantine-color-body);
}

/* Empty / placeholder / unavailable sections. */
.root[data-variant='dotted'] {
    border: 1px dashed
        light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));
    background-color: transparent;
    box-shadow: none;
}
